import { showErrorMessage } from '../../messages';
import { push } from 'react-router-redux';
import {
  BUILDINGS_NEW_ENGINEER_ADD,
  BUILDINGS_LOAD_SUCCESS,
  BUILDINGS_NEW_CLEAR_DATA,
  BUILDINGS_NEW_FORM_VALUE_CHANGE,
  BUILDINGS_NEW_UNIONS_LOAD_SUCCESS,
  BUILDINGS_NEW_PARKING_ON_SITE_SELECT,
  BUILDINGS_NEW_UNIONS_SELECT,
  BUILDINGS_NEW_CONTRACTOR_SELECT,
  BUILDINGS_NEW_CONTRACTOR_REMOVE,
  BUILDINGS_NEW_FILES_ADD,
  BUILDINGS_NEW_FILE_REMOVE,
  BUILDINGS_NEW_FORM_INVALID,
  BUILDINGS_NEW_FORM_VALID,
  BUILDINGS_BUILDING_LOAD_SUCCESS,
  BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS,
  BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE,
  BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS,
  BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT,
  BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS,
  BUILDINGS_NEW_CLIENT_SELECT,
  BUILDINGS_NEW_CLIENT_REMOVE,
  BUILDINGS_SET_PAGINATION_DATA,
} from 'actions/admin/buildings/action-types';
import { buildingsApi } from 'services/api/buildings-api';
import { unionsApi } from 'services/api/union-api';
import { clientsApi } from 'services/api/clients-api';

export const baseRoutePath = '/admin/buildings';

export function addEngineer() {
  return {
    type: BUILDINGS_NEW_ENGINEER_ADD,
  };
}

export function addFiles(files) {
  return {
    type: BUILDINGS_NEW_FILES_ADD,
    payload: files,
  };
}

export function changePage(newPage) {
  return {
    type: BUILDINGS_BUILDING_WORK_ORDERS_PAGE_CHANGE,
    payload: newPage,
  };
}

export function editBuilding(buildingId) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${buildingId}/edit`));
  };
}

export function goToBuilding(buildingId) {
  return (dispatch) => {
    dispatch(push(`${baseRoutePath}/${buildingId}`));
  };
}

export function loadBuildingDetailsRequest(buildingId, loadClients) {
  return (dispatch) => {
    let promises = [];
    promises.push(buildingsApi.getBuilding(buildingId));

    if (loadClients) {
      promises.push(clientsApi.getClients());
    }

    return Promise.all(promises).then((values) => {
      const result = {};
      if (values[0].ok && (!loadClients || values[1].ok)) {
        dispatch(loadBuildingSuccess(values[0].building));

        if (loadClients) {
          dispatch(loadClientsSuccess(values[1].clients));
        }

        dispatch(changePage(1));
        result.ok = true;
      } else {
        let errors = [];
        if (!values[0].ok) {
          errors = errors.concat(values[0].errors);
        }
        if (loadClients && !values[1].ok) {
          errors = errors.concat(values[1].errors);
        }
        dispatch(showErrorMessage(errors));
        result.ok = false;
      }

      return result;
    });
  };
}

export function loadBuildingSuccess(building) {
  return {
    type: BUILDINGS_BUILDING_LOAD_SUCCESS,
    payload: building,
  };
}

export function loadClientsRequest() {
  return (dispatch) => {
    return clientsApi.getClients().then((response) => {
      const result = {};
      if (response.ok) {
        dispatch(loadClientsSuccess(response.clients));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return result;
    });
  };
}

export function loadClientsSuccess(clients) {
  return {
    type: BUILDINGS_BUILDING_CLIENTS_LOAD_SUCCESS,
    payload: clients,
  };
}

export function loadWorkOrdersSuccess(workOrders) {
  return {
    type: BUILDINGS_BUILDING_WORK_ORDERS_LOAD_SUCCESS,
    payload: workOrders,
  };
}

export function loadProjectsSuccess(projects) {
  return {
    type: BUILDINGS_BUILDING_PROJECTS_LOAD_SUCCESS,
    payload: projects,
  };
}

export function selectContractor(contractor) {
  return {
    type: BUILDINGS_NEW_CONTRACTOR_SELECT,
    payload: contractor,
  };
}

export function removeContractor(selectedContractorId) {
  return {
    type: BUILDINGS_NEW_CONTRACTOR_REMOVE,
    payload: selectedContractorId,
  };
}

export function loadBuildingsRequest(page) {
  return (dispatch) => {
    return buildingsApi.getBuildings(undefined, page).then((response) => {
      if (response.ok) {
        dispatch(loadBuildingsSuccess(response.buildings));

        if (page) {
          dispatch(
            setBuildingsPaginationData(page, response.total, response.pageSize)
          );
        }
      } else {
        dispatch(showErrorMessage(response.errors));
      }
    });
  };
}

export function loadBuildingsSuccess(buildings) {
  return {
    type: BUILDINGS_LOAD_SUCCESS,
    payload: buildings,
  };
}

export function setBuildingsPaginationData(page, total, pageSize) {
  return {
    type: BUILDINGS_SET_PAGINATION_DATA,
    payload: { page: page, total: total, pageSize: pageSize },
  };
}

export function loadWorkOrdersRequest(
  buildingId,
  page,
  workOrderStatus,
  critical
) {
  return (dispatch) => {
    return buildingsApi
      .getWorkOrders(buildingId, page, workOrderStatus, critical)
      .then((response) => {
        if (response.ok) {
          dispatch(loadWorkOrdersSuccess(response.workOrders));
          dispatch(changePage(page));
        } else {
          dispatch(showErrorMessage(response.errors));
        }

        return response;
      });
  };
}

export function loadProjectsRequest(buildingId, page) {
  return (dispatch) => {
    return buildingsApi.getProjects(buildingId, page).then((response) => {
      if (response.ok) {
        dispatch(loadProjectsSuccess(response.projects));
        dispatch(changePage(page));
      } else {
        dispatch(showErrorMessage(response.errors));
      }

      return response;
    });
  };
}

export function loadUnionsRequest(unions) {
  return (dispatch) => {
    if (unions === undefined || unions.length === 0) {
      return unionsApi.getUnions().then((response) => {
        if (response.ok) {
          dispatch(loadUnionsSuccess(response.unions));
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
    } else {
      return Promise.resolve([]);
    }
  };
}

export function loadUnionsSuccess(unions) {
  return {
    type: BUILDINGS_NEW_UNIONS_LOAD_SUCCESS,
    payload: unions,
  };
}

export function newBuilding() {
  return (dispatch) => {
    dispatch(clearBuildingData());
    dispatch(push(baseRoutePath + '/new'));
  };
}

export function clearBuildingData() {
  return {
    type: BUILDINGS_NEW_CLEAR_DATA,
  };
}

export function removeClient(clientId) {
  return {
    type: BUILDINGS_NEW_CLIENT_REMOVE,
    payload: clientId,
  };
}

export function removeFile(index) {
  return {
    type: BUILDINGS_NEW_FILE_REMOVE,
    payload: index,
  };
}

export function selectClient(clientId) {
  return {
    type: BUILDINGS_NEW_CLIENT_SELECT,
    payload: clientId,
  };
}

export function selectParkingOnSite(value) {
  return {
    type: BUILDINGS_NEW_PARKING_ON_SITE_SELECT,
    payload: value === 'true',
  };
}

export function selectUnion(value, unions, selectedUnionsId) {
  let newUnions = [];
  if (value === 'all') {
    if (unions.length !== selectedUnionsId.length) {
      // Select all (in the other case, just return an empty array)
      newUnions = unions.map((element) => element.id);
    }
  } else {
    if (selectedUnionsId.find((element) => element === value) !== undefined) {
      newUnions = selectedUnionsId.filter((element) => element !== value);
    } else {
      newUnions = selectedUnionsId.concat(value);
    }
  }

  return {
    type: BUILDINGS_NEW_UNIONS_SELECT,
    payload: newUnions,
  };
}

export function submitFormRequest(
  form,
  selectedUnionsId,
  selectedContractors,
  files,
  parkingOnSite,
  buildingId,
  selectedClientsId
) {
  return (dispatch) => {
    // Validate form
    const requiredFields = ['streetAddress', 'city', 'state', 'zipCode'];
    const invalidFields = [];
    requiredFields.forEach((attribute) => {
      if (form[attribute] === '') {
        invalidFields.push(attribute);
      }
    });

    if (invalidFields.length > 0) {
      dispatch(
        invalidForm(
          invalidFields,
          'The outlined inputs should be added in order to add a building.'
        )
      );
    } else {
      dispatch(validForm());

      const data = createBuildingDataObject(
        form,
        parkingOnSite,
        files,
        selectedContractors,
        selectedUnionsId,
        selectedClientsId
      );
      let promise;
      if (buildingId !== undefined) {
        promise = buildingsApi.updateBuilding(buildingId, data);
      } else {
        promise = buildingsApi.createBuilding(data);
      }

      return promise.then((response) => {
        if (response.ok) {
          if (buildingId !== undefined) {
            dispatch(loadBuildingSuccess(response.building));
            dispatch(goToBuilding(buildingId));
          } else {
            dispatch(push(baseRoutePath));
          }
        } else {
          dispatch(showErrorMessage(response.errors));
        }
      });
    }
  };
}

export function createBuildingDataObject(
  form,
  parkingOnSite,
  files,
  selectedContractors,
  selectedUnionsId,
  selectedClientsId
) {
  const data = {
    name: form.buildingName,
    propOwnerName: form.propOwnerName,
    parkingOnSite: parkingOnSite,
    location: {
      id: form.locationId,
      streetAddress: form.streetAddress,
      city: form.city,
      state: form.state,
      zipCode: form.zipCode,
    },
    // filter all files not removed that are not backend document
    documentsToAdd: files
      .filter((element) => !element.removed && element.file !== null)
      .map((element) => element.file),
    // filter all files removed that are backend documents
    documentsIdToRemove: files
      .filter((element) => element.removed && element.document !== null)
      .map((element) => element.document.id),
    clientsId: selectedClientsId !== undefined ? selectedClientsId : [],
    contractorsId: selectedContractors.map((element) => element.value),
    unionsId: selectedUnionsId,
  };

  if (
    form.propOwnerAddressId ||
    form.propOwnerStreetAddress ||
    form.propOwnerUnitNumber ||
    form.propOwnerCity ||
    form.propOwnerState ||
    form.propOwnerZipCode
  ) {
    data['propOwnerAddress'] = {
      id: form.propOwnerAddressId,
      streetAddress: form.propOwnerStreetAddress,
      unitNumber: form.propOwnerUnitNumber,
      city: form.propOwnerCity,
      state: form.propOwnerState,
      zipCode: form.propOwnerZipCode,
    };
  }

  data['manager'] = {
    firstName: form.managerFirstName,
    lastName: form.managerLastName,
    email: form.managerEmail,
    phoneNumber: form.managerPhoneNumber,
  };

  data['engineer'] = {
    firstName: form.engineerFirstName,
    lastName: form.engineerLastName,
    email: form.engineerEmail,
    phoneNumber: form.engineerPhoneNumber,
  };

  if (form.unitNumber !== '') {
    data['location']['unitNumber'] = form.unitNumber;
  }

  return data;
}

export function invalidForm(invalidFields, message) {
  return {
    type: BUILDINGS_NEW_FORM_INVALID,
    payload: { invalidFields, message },
  };
}

export function validForm() {
  return {
    type: BUILDINGS_NEW_FORM_VALID,
  };
}

export function updateFormFromCurrentBuilding(currentBuilding) {
  return {
    type: BUILDINGS_EDIT_FORM_LOAD_FROM_CURRENT,
    payload: currentBuilding,
  };
}

export function updateFormValue(attribute, value) {
  return {
    type: BUILDINGS_NEW_FORM_VALUE_CHANGE,
    payload: { attribute, value },
  };
}



// WEBPACK FOOTER //
// ./src/actions/admin/buildings/buildings.js